import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { array, bool, object } from 'prop-types';
import cx from 'classnames';

import useStyles from 'hooks/useStyles';

import {
  COURSE_LESSONPAGE_MATERIAL_CLICK,
  COURSE_MATERIAL_CLICK,
} from 'constants/gtmEvent';
import { MATERIALS_TAB } from 'constants/courseEventSections';

import Link from 'components/Link';
import { MaterialIcon, LockIcon } from 'components/Icon';

import CourseContext from 'routes/course/components/CourseContext';

import { sendGTMEvent } from 'reduxModules/googleTagManager/action';

import styles from './Material.scss';

function Material({
  isDisable,
  lessonEventTrackData,
  materials,
  isLessonPage,
}) {
  useStyles(styles);
  const dispatch = useDispatch();
  const { courseEventTrackData } = useContext(CourseContext);

  const sentMaterialEventTrackData = ({ id, title }) => {
    if (isLessonPage) {
      dispatch(
        sendGTMEvent({
          eventName: COURSE_LESSONPAGE_MATERIAL_CLICK,
          data: {
            courseId: courseEventTrackData.courseId,
            courseName: courseEventTrackData.courseName,
            freeLesson: lessonEventTrackData.freeLesson,
            lessonId: lessonEventTrackData.lessonId,
            lessonName: lessonEventTrackData.lessonName,
            materialId: id,
            materialName: title,
            section: MATERIALS_TAB,
          },
        }),
      );
    } else {
      dispatch(
        sendGTMEvent({
          eventName: COURSE_MATERIAL_CLICK,
          data: {
            materialId: id,
            materialName: title,
            section: 'course_player_materials_tab',
            ...courseEventTrackData,
            ...lessonEventTrackData,
          },
        }),
      );
    }
  };

  const renderMaterials = ({ id, title, file }) => {
    return (
      <div
        className={cx(styles.materialButton, { [styles.disable]: isDisable })}
        key={id}
        onClick={() => sentMaterialEventTrackData({ id, title })}
      >
        {file ? (
          <Link to={file} newTab className={styles.wrapper}>
            <MaterialIcon width={24} height={24} className={styles.icon} />
            <div className={styles.materialName}>{title} </div>
            {isDisable && (
              <LockIcon width={24} height={24} className={styles.icon} />
            )}
          </Link>
        ) : (
          <div className={styles.wrapper}>
            <MaterialIcon width={24} height={24} className={styles.icon} />
            <div className={styles.materialName}>{title} </div>
            {isDisable && (
              <LockIcon width={24} height={24} className={styles.icon} />
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={styles.root}>
      {materials.map(material => renderMaterials(material))}
    </div>
  );
}

Material.propTypes = {
  isDisable: bool,
  lessonEventTrackData: object,
  materials: array.isRequired,
  isLessonPage: bool.isRequired,
};

Material.defaultProps = {
  isDisable: false,
  lessonEventTrackData: undefined,
};

export default Material;
